import jQuery from 'jquery';
(window as any)['jQuery'] = jQuery;
(window as any)['$'] = jQuery;

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { environment } from 'environments/environment';
import { EnvironmentValidator } from 'app/core/config/environment-validator';

// Validate environment configuration for security
EnvironmentValidator.validate(environment);

// Hide splash immediately on startup if a one-time flag is set
try {
    const suppress = sessionStorage.getItem('suppressSplashOnce');
    if (suppress === 'true') {
        document.body.classList.add('fuse-splash-screen-hidden');
        sessionStorage.removeItem('suppressSplashOnce');
    }
} catch {}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
